import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'catalogo',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Catálogo' }] },
        loadComponent: () => import('./pages/catalogo-lista/catalogo-lista.component'),
      },
     /*  {
        path: 'editar/:catalogoId',
        title,
        data: { ...data, urls: [{ url: '/catalogo', title: 'Catálogo' }, { title: 'Editar catalogo' }] },
        loadComponent: () => import('./pages/catalogo-registro/catalogo-registro.component'),
      }, */
      {
        path: 'item/:codigo',
        title,
        data: { ...data, urls: [{ url: '/catalogo', title: 'Catálogo' }, { title: 'Items catalogo' }] },
        loadComponent: () => import('./pages/catalogo-item/catalogo-item.component'),
      },
     /*  {
        path: 'item/:codigo/registro/:referenciaCodigo',
        title,
        data: { ...data, urls: [{ url: '/catalogo', title: 'Catálogo' }, { title: 'Item nuevo' }] },
        loadComponent: () => import('./pages/catalogo-registro/catalogo-registro.component'),
      },
      {
        path: 'item/:codigo/editar/:referenciaCodigo/:catalogoId',
        title,
        data: { ...data, urls: [{ url: '/catalogo', title: 'Catálogo' }, { title: 'Item editar' }] },
        loadComponent: () => import('./pages/catalogo-registro/catalogo-registro.component'),
      }, */
    
    ],
  },
];
